import { SubAPI } from "./SubAPI";
export class UserNotifications extends SubAPI {
    list(input) { return this.fetcher.get("/api/user-notifications", input); }
    upsert(input) { return this.fetcher.post("/api/user-notification", input); }
    upsertBulk(input) { return this.fetcher.post("/api/user-notification/bulk", input); }
}
